import { useEffect, useState } from "react";
import client from "@/lib/api";
import Layout, { PageHeader } from "@/components/Layout";
import { toast } from "sonner";
import { ToggleLeft, ToggleRight, Blocks } from "lucide-react";

export default function AddonManager() {
  const [addons, setAddons] = useState([]);
  const load = () => client.get("/addons").then((r) => setAddons(r.data.addons || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const toggle = async (a) => {
    try {
      await client.post(`/addons/${a.key}`, { enabled: !a.enabled });
      toast.success(`${a.label.split(" (")[0]} ${!a.enabled ? "ENABLED" : "DISABLED"}`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Toggle failed"); }
  };
  return (
    <Layout>
      <PageHeader title="Add-On Manager" sub="Enable or disable each MATCOM add-on. New add-ons default OFF until approved." icon={Blocks} />
      <div className="p-4 max-w-3xl space-y-2" data-testid="addon-manager">
        {addons.map((a) => (
          <button key={a.key} data-testid={`addon-toggle-${a.key}`} onClick={() => toggle(a)}
            className="w-full flex items-center gap-3 px-4 py-3 border border-[#2C2D35] bg-[#141518] rounded-sm text-left hover:border-[#22D3EE]">
            {a.enabled ? <ToggleRight size={22} className="text-[#10B981] shrink-0" /> : <ToggleLeft size={22} className="text-[#6B7280] shrink-0" />}
            <div>
              <div className="text-sm font-semibold text-white">{a.label}</div>
              <div className="font-mono text-[10px]" style={{ color: a.enabled ? "#10B981" : "#6B7280" }}>
                {a.enabled ? "ENABLED" : "DISABLED — hidden from all portals"}
              </div>
            </div>
          </button>
        ))}
        {!addons.length && <div className="font-mono text-xs text-[#9CA3AF]">Loading add-ons…</div>}
      </div>
    </Layout>
  );
}
